import { useCallback, useMemo, useState } from 'react';

import { NotificationDto } from 'src/generated/services/TFinancialApi';
import { INotificationSelectorProps, NotificationSelectorContext } from './NotificationContext';

export const NotificationSelector = ({ children }: INotificationSelectorProps) => {
  // UI State Management
  const [isShowContent, setIsShowContent] = useState<boolean>(false);
  const [isShowDetail, setIsShowDetail] = useState<boolean>(false);
  const [selectedDetail, setSelectedDetail] = useState<NotificationDto>(null);

  // Filter State Management
  const [dateFilter, setDateFilter] = useState<string>('ALL');

  // Combined Actions
  const onShowDetail = useCallback((notification: NotificationDto) => {
    setSelectedDetail(notification);
    setIsShowDetail(true);
  }, []);

  const onHideDetail = useCallback(() => {
    setIsShowDetail(false);
    setSelectedDetail(null);
  }, []);

  const onResetState = useCallback(() => {
    setIsShowContent(false);
    setIsShowDetail(false);
    setSelectedDetail(null);
    setDateFilter('ALL');
  }, []);

  const value = useMemo(
    () => ({
      // UI State
      isShowContent,
      isShowDetail,
      selectedDetail,

      // Filter State
      dateFilter,

      // Actions
      setIsShowContent,
      setIsShowDetail,
      setSelectedDetail,
      setDateFilter,

      // Combined Actions
      onShowDetail,
      onHideDetail,
      onResetState,
    }),
    [
      isShowContent,
      isShowDetail,
      selectedDetail,
      dateFilter,
      setIsShowContent,
      setIsShowDetail,
      setSelectedDetail,
      setDateFilter,
      onShowDetail,
      onHideDetail,
      onResetState,
    ]
  );

  return <NotificationSelectorContext.Provider value={value}>{children}</NotificationSelectorContext.Provider>;
};
